import validate from "/var/www/panel/node_modules/nuxt/dist/pages/runtime/validate.js";
import csrf_45global from "/var/www/panel/middleware/csrf.global.ts";
import manifest_45route_45rule from "/var/www/panel/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  csrf_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/var/www/panel/middleware/auth.ts"),
  checkboxes: () => import("/var/www/panel/middleware/checkboxes.ts"),
  contact: () => import("/var/www/panel/middleware/contact.ts"),
  decisions: () => import("/var/www/panel/middleware/decisions.ts"),
  documents: () => import("/var/www/panel/middleware/documents.ts"),
  guest: () => import("/var/www/panel/middleware/guest.ts"),
  home: () => import("/var/www/panel/middleware/home.ts"),
  journals: () => import("/var/www/panel/middleware/journals.ts"),
  schedule: () => import("/var/www/panel/middleware/schedule.ts"),
  settlements: () => import("/var/www/panel/middleware/settlements.ts"),
  "single-journal": () => import("/var/www/panel/middleware/single-journal.ts"),
  "validate-confirm-email": () => import("/var/www/panel/middleware/validate-confirm-email.ts"),
  "validate-reset-token": () => import("/var/www/panel/middleware/validate-reset-token.ts")
}